module.exports = __webpack_public_path__ + "img/atari1200_page17.7d590733.jpg";